import formatTableJson from '@manage/config/tableComponentParams.js'
import { YNColor } from '@manage/config/StateColorEmun'
export default formatTableJson([
  {
    filed: 'name',
    label: '菜单名称',
    width: '250'
  },
  {
    filed: 'url',
    label: 'url',
    width: '250'
  },
  {
    filed: 'treeNum',
    label: '菜单等级'
  },
  {
    filed: 'sortNum',
    label: '排序号'
  },
  {
    filed: 'state',
    label: '状态',
    type: 'tag',
    formatFn: function (_, row) {
      let dic = {
        Y: '启用',
        N: '禁用'
      }
      return dic[row.state]
    },
    colorList: YNColor
  },
  {
    filed: 'isOperation',
    label: '是否操作按钮',
    width: '150',
    type: 'tag',
    formatFn: function (_, row) {
      let dic = {
        Y: '是',
        N: '否'
      }
      return dic[row.isOperation]
    },
    colorList: YNColor
  }
])
